import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  const rankColors: Record<number, string> = {
    1: 'bg-accent-500 text-background-50',
    2: 'bg-primary-500 text-background-50',
    3: 'bg-secondary-500 text-background-50',
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            本周最受欢迎影片排行，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors duration-200 cursor-pointer border border-transparent hover:border-background-200/60"
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${rankColors[item.rank] || 'bg-background-200 text-foreground-600'}`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                    {item.title}
                  </h3>
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                  )}
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1">
                <i className="ri-star-fill text-primary-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                <span className="text-sm font-bold text-primary-500">{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}